{
  "previous": "Previous",
  "next": "Next",
  "complete": "Complete",
  "verifyAndCheckIn": "Verify and check-in",
  "loading": {
    "retrievingLocation": "Retrieving location...",
    "retrievingWarehouse": "Retrieving warehouse data..."
  },
  "validation": {
    "fieldRequired": "This field is required",
    "fieldRequiredWithLabel": "{label} is required",
    "phoneInvalid": "This is not a valid phone number",
    "phoneInvalidWithExample": "This is not a valid phone number (example: {example})"
  }
}
